import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { Ng2FittextModule } from 'ng2-fittext';
import { NgxMaskModule } from 'ngx-mask';
import { ImageModule } from '@components/admin/image/image.module';
import { AdminSharedModule } from '@modules/admin-shared/admin-shared.module';
import { FormFavoritesComponent } from '@components/admin/patient/form-favorites/form-favorites.component';
import { FormPatientComponent } from '@components/admin/patient/form-patient/form-patient.component';
import { FormPrescriptionComponent } from '@components/admin/patient/form-prescription/form-prescription.component';
import { FormPrescriptionGroupComponent } from '@components/admin/patient/form-prescription-group/form-prescription-group.component';
import { ImportCustomerImagesComponent } from '@components/admin/patient/import-customer-images/import-customer-images.component';
import { FormOrderImageComponent } from '@components/admin/patient/form-order-image/form-order-image.component';
import { FormOrderImageGroupComponent } from '@components/admin/patient/form-order-image-group/form-order-image-group.component';
import { PatientInquiriesComponent } from '@components/admin/patient/patient-inquiries/patient-inquiries.component';
import { PatientOrdersComponent } from '@components/admin/patient/patient-orders/patient-orders.component';
import { PatientOrderTableComponent } from '@components/admin/patient/patient-order-table/patient-order-table.component';
import { PatientOrderDetailsComponent } from '@components/admin/patient/patient-order-details/patient-order-details.component';
import { ReturnOrderDialogComponent } from '@components/admin/patient/return-order-dialog/return-order-dialog.component';
import { RestyleOrderDialogComponent } from '@components/admin/patient/restyle-order-dialog/restyle-order-dialog.component';
import { RepairOrderDialogComponent } from '@components/admin/patient/repair-order-dialog/repair-order-dialog.component';
import { RedoOrderDialogComponent } from '@components/admin/patient/redo-order-dialog/redo-order-dialog.component';
import { EmailOrderDialogComponent } from '@components/admin/patient/email-order-dialog/email-order-dialog.component';
import { DeleteOrderDialogComponent } from '@components/admin/patient/delete-order-dialog/delete-order-dialog.component';
import { HoldFollowUpDialogComponent } from '@components/admin/patient/hold-follow-up-dialog/hold-follow-up-dialog.component';
import { InternalNoteDialogComponent } from '@components/admin/patient/internal-note-dialog/internal-note-dialog.component';
import { OrderEditDialogComponent } from '@components/admin/patient/order-edit-dialog/order-edit-dialog.component';
import { PatientComponent } from '@components/admin/patient/patient.component';
import { PatientsComponent } from '@components/admin/patients/patients.component';
import { OrderComponent } from '@components/admin/order/order.component';
import { FrameDetailsComponent } from '@components/admin/order/frame-details/frame-details.component';
import { TaskActivityComponent } from '@components/admin/order/task-activity/task-activity.component';
import { PrescriptionDetailsComponent } from '@components/admin/order/prescription-details/prescription-details.component';
import { LensDetailsComponent } from '@components/admin/order/lens-details/lens-details.component';
import { PaymentDetailsComponent } from '@components/admin/order/payment-details/payment-details.component';
import { RepairDetailsComponent } from '@components/admin/order/repair-details/repair-details.component';
import { OrderLogDialogComponent } from '@components/admin/order/order-log-dialog/order-log-dialog.component';
import { LastEditorFieldComponent } from '@components/admin/order/last-editor-field/last-editor-field.component';
import { OrderSaveMenuComponent } from '@components/admin/order/order-save-menu/order-save-menu.component';
import { PrescriptionsComponent } from '@components/admin/patient/prescriptions/prescriptions.component';
import { PrescriptionComponent } from '@components/admin/patient/prescription/prescription.component';
import { PrescriptionSideComponent } from '@components/admin/patient/prescription/prescription-side/prescription-side.component';

const PATIENT_DECLARATIONS = [
  FormFavoritesComponent,
  FormPatientComponent,
  FormPrescriptionComponent,
  FormPrescriptionGroupComponent,
  ImportCustomerImagesComponent,
  FormOrderImageComponent,
  FormOrderImageGroupComponent,
  PatientInquiriesComponent,
  PatientOrdersComponent,
  PatientOrderTableComponent,
  PatientOrderDetailsComponent,
  ReturnOrderDialogComponent,
  RestyleOrderDialogComponent,
  RepairOrderDialogComponent,
  RedoOrderDialogComponent,
  EmailOrderDialogComponent,
  DeleteOrderDialogComponent,
  HoldFollowUpDialogComponent,
  InternalNoteDialogComponent,
  OrderEditDialogComponent,
  PatientComponent,
  PatientsComponent,
  OrderComponent,
  FrameDetailsComponent,
  TaskActivityComponent,
  PrescriptionDetailsComponent,
  LensDetailsComponent,
  PaymentDetailsComponent,
  RepairDetailsComponent,
  OrderLogDialogComponent,
  LastEditorFieldComponent,
  OrderSaveMenuComponent,
  PrescriptionsComponent,
  PrescriptionComponent,
  PrescriptionSideComponent,
];

@NgModule({
  declarations: PATIENT_DECLARATIONS,
  imports: [
    AdminSharedModule,
    FileUploadModule,
    CKEditorModule,
    Ng2FittextModule,
    NgxMaskModule,
    ImageModule,
  ],
  exports: PATIENT_DECLARATIONS,
  entryComponents: [
    ReturnOrderDialogComponent,
    RestyleOrderDialogComponent,
    RepairOrderDialogComponent,
    RedoOrderDialogComponent,
    EmailOrderDialogComponent,
    DeleteOrderDialogComponent,
    HoldFollowUpDialogComponent,
    InternalNoteDialogComponent,
    OrderEditDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PatientModule {}
